var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-out"},[_c('div',{staticClass:"progress-in",style:({width: _vm.progress + '%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }